/**
 * Fetches if has phone number information from the backend API
 * @param {string} cookieToken - The cookie token to send in the request body
 * @returns {Promise<Boolean>} - Promise that resolves to the phone number data
 */
export const getHasPhoneNumberInfo = async (cookieToken) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/api/v1/person/phone-number`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: cookieToken,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.value;
  } catch (error) {
    console.error('Error fetching phone number information:', error);
    throw error;
  }
}; 